<template>
    <div>
        <!-- 警告弹窗（已注释） -->
        <div class="high-tech-table-container">
            <div class="table-wrapper">
                <table>
                    <!-- 表头 -->
                    <thead>
                        <tr>
                            <th>地址</th>
                            <th>温度</th>
                            <th>湿度</th>
                        </tr>
                    </thead>
                    <!-- 表格数据 -->
                    <tbody @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave" @wheel="handleWheel">
                        <!-- 添加 loading 状态 -->
                        <tr v-if="loading">
                            <td colspan="3" style="text-align: center;">加载中...</td>
                        </tr>
                        <tr v-else-if="!data || data.length === 0">
                            <!-- <td colspan="3" style="text-align: center;">暂无数据</td> -->
                        </tr>
                        <tr v-else v-for="(item, index) in data" :key="index">
                            <td>{{ item.sName }}</td>
                            <td>{{ item.sTemperature }}°C</td>
                            <td>{{ item.sHumidity }}%</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            allDate: [],
            tableData: [],
            startValue: 0,
            endValue: 5,
            data: [],
            loading: false, // 添加加载状态
            timerId: null,   // 明确声明定时器ID
            isWheelActive: false, // 滚轮操作状态标志
            wheelTimeout: null, // 滚轮操作超时定时器
            autoScrollEnabled: true // 添加自动滚动启用标志
        };
    },
    methods: {
        async getData() {
            this.loading = true; // 开始加载
            try {
                const { data: ret } = await this.$http.get("sensor/getTemperature");
                this.allDate = ret;
                // 筛选数据
                this.tableData = this.allDate.filter(item => ![1, 2, 3, 4, 5, 6].includes(item.sId));


                
                //更新显示数据
                this.updateDisplayData();
                
            } catch (error) {
                console.error('获取数据失败:', error);
            } finally {
                this.loading = false; 
            }
        },
        
        // 更新显示数据
        updateDisplayData() {
            if (this.tableData && this.tableData.length > 0) {
                // 确保索引不超过数组长度
                const start = this.startValue % this.tableData.length;
                const end = Math.min(this.endValue, this.tableData.length);
                this.data = this.tableData.slice(start, end);
            } else {
                this.data = [];
            }
        },
        
        // 鼠标移入清除定时器
        handleMouseEnter() {
            if (this.timerId) {
                clearInterval(this.timerId);
                this.timerId = null;
            }
        },
        
        // 鼠标移出恢复滚动
        handleMouseLeave() {
            this.startInterver();
        },
        
        // 处理滚轮
        handleWheel(event) {
            if (!this.tableData || this.tableData.length <= 5) return;
            
            event.preventDefault();
            
            if (this.wheelTimeout) {
                clearTimeout(this.wheelTimeout);
            }
            this.isWheelActive = true;
            this.autoScrollEnabled = false;
            if (event.deltaY > 0) {
                this.startValue++;
                this.endValue++;
                
                // 检查是否超出数据范围
                if (this.endValue > this.tableData.length) {
                    this.startValue = 0;
                    this.endValue = 5;
                }
            } else {
                this.startValue--;
                this.endValue--;
                
                // 检查是否小于0
                if (this.startValue < 0) {
                    this.startValue = this.tableData.length - 5;
                    this.endValue = this.tableData.length;
                }
            }
            
            this.updateDisplayData();
            
            this.wheelTimeout = setTimeout(() => {
                this.isWheelActive = false;
                this.autoScrollEnabled = true;
            }, 10); 
        },
        
        // 启动定时器
        startInterver() {
            if (this.isWheelActive) return;
            
            if (this.timerId) {
                clearInterval(this.timerId);
            }
            
            // 立即更新一次数据
            this.updateDisplayData();
            
            // 设置定时器
            this.timerId = setInterval(() => {
                if (this.isWheelActive) return;
                this.getDataForInterval();
            }, 1000); // 10秒
        },
        
        // 定时器获取数据
        async getDataForInterval() {
            try {
                const { data: ret } = await this.$http.get("sensor/getTemperature");
                this.allDate = ret;
                // 筛选数据
                this.tableData = this.allDate.filter(item => ![1, 2, 3, 4, 5, 6].includes(item.sId));
                
                // 更新滚动索引
                this.startValue++;
                this.endValue++;
                
                // 重置索引
                if (this.endValue > this.tableData.length) {
                    this.startValue = 0;
                    this.endValue = 5;
                }
                
                // 更新显示数据
                this.updateDisplayData();
                
            } catch (error) {
                console.error('定时获取数据失败:', error);
            }
        }
    },
    
    mounted() {
        // 先获取数据，数据获取成功后再启动定时器
        this.getData().then(() => {
            // 数据获取完成后启动定时器
            this.startInterver();
        });
    },
    
    beforeDestroy() {
        // 组件销毁前清除定时器
        if (this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
        // 清除滚轮超时定时器
        if (this.wheelTimeout) {
            clearTimeout(this.wheelTimeout);
            this.wheelTimeout = null;
        }
    }
};
</script>
<style scoped>
.high-tech-table-container {
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    /* background: linear-gradient(135deg, #0f0c29, #302b63, #24243e); */
    /* 深蓝色渐变背景 */
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    font-family: 'Orbitron', sans-serif;
    /* 科技感字体 */
}

.table-wrapper {
    bottom: 10px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 15px;
    border: 2px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
    backdrop-filter: blur(10px);
}

table {
    width: 100%;
    border-collapse: collapse;
}

th,
td {
    padding: 15px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

th {
    background: linear-gradient(135deg, #00d2ff, #3a7bd5);
    /* 表头渐变背景 */
    color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    /* 字母大写 */
    position: sticky;
    top: 0;
    /* 表头固定在顶部 */
    z-index: 1;
}

tbody tr {
    transition: all 0.3s ease;
}

tbody tr:hover {
    background: rgba(255, 255, 255, 0.1);
    /* 悬浮时背景变亮 */
    transform: scale(1.02);
    /* 悬浮时放大 */
}

/* 滚动条样式 */
.table-wrapper::-webkit-scrollbar {
    width: 8px;
}

.table-wrapper::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
}

.table-wrapper::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #00d2ff, #3a7bd5);
    border-radius: 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {

    th,
    td {
        padding: 12px;
        font-size: 14px;
    }
}

@media (max-width: 480px) {

    th,
    td {
        padding: 10px;
        font-size: 12px;
    }
}
</style>